import React, { Component } from 'react';
import Loader from 'react-loader-spinner';

import './Loading.css';

class Loading extends Component {
  render() {
    return (
      <div className="loading" hidden={ this.props.hidden }>
          <div>
              <Loader type="TailSpin" color="rgb(56, 56, 56)" height={25} width={25}/>
              <div className="loader-text">Loading...</div>
          </div>
      </div>
    );
  }
}

export default Loading;
